// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  bank_code: yup.string().label("BANK code").required(),
  bank_name: yup.string().label("BANK name").required()
})